module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.catalogRequests.length !== 0) ? _c('button', {
    staticClass: "button is-primary is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.printAll()
      }
    }
  }, [_vm._v("\n            Print All\n        ")]) : _vm._e(), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.catalogRequests,
      "page-length": 50,
      "columns": [{
          name: 'Contact',
          prop: ['first_name', 'last_name', 'email', 'phone'],
          type: 'text'
        },
        {
          name: 'Address',
          prop: ['line1', 'line2', 'line3', 'city', 'state', 'zip', 'country'],
          type: 'text'
        },
        {
          name: 'Referrer',
          prop: 'referrer',
          type: 'text'
        },
        {
          name: 'Status',
          prop: 'printed',
          type: 'number',
          searchable: false
        },
        {
          name: 'Created',
          prop: 'created_at',
          type: 'date',
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Contact",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name) + "\n                "), _c('br'), _vm._v("\n                " + _vm._s(props.row.email) + "\n                "), (props.row.phone) ? _c('br') : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("phone")(props.row.phone)) + "\n            ")]
      }
    }, {
      key: "column_Address",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.row.line1) + "\n                "), (props.row.line2) ? _c('br') : _vm._e(), _vm._v("\n                " + _vm._s(props.row.line2) + "\n                "), (props.row.line3) ? _c('br') : _vm._e(), _vm._v("\n                " + _vm._s(props.row.line3) + "\n                "), _c('br'), _vm._v("\n                " + _vm._s(props.row.city) + ", " + _vm._s(props.row.state) + " " + _vm._s(props.row.zip) + " " + _vm._s(props.row.country) + "\n            ")]
      }
    }, {
      key: "column_Status",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.row.printed ? 'Printed' : 'Not Printed') + "\n            ")]
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4119a3ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/mailing/Requests.vue
// module id = 528
// module chunks = 0